import * as GlobalRoutes from 'generated/routes';
export const routes = [...Object.values(GlobalRoutes)];
